/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setpoint_Temp_Summer_ModeInputs */



/**
* | output |
* | --- |
* | "Summer mode enabled: th. heads are open" |
*
* @param {Setpoint_Temp_Summer_ModeInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const setpoint_temp_summer_mode = /** @type {((inputs?: Setpoint_Temp_Summer_ModeInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setpoint_Temp_Summer_ModeInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Summer mode enabled: th. heads are open")
	return /** @type {LocalizedString} */ ("Mode été activé: les têtes th. sont ouvertes")
});